<template>
    <div class="app-box">
        <vue-scroll-snap @scroll="checkScroll">
            <div class="item" id="block1" ref="block1"><img src="/img/otc/k1.jpg" class="imgs" /></div>
            <div class="item" id="block2" ref="block2">
                <img src="/img/otc/k2.jpg" class="imgs" />
            </div>
            <div class="item" id="block3" ref="block3">
                <img src="/img/otc/k3.jpg" class="imgs" />
            </div>
        </vue-scroll-snap>
        <div class="circle-box">
            <div class="">
                <div
                    v-for="i in slideCount"
                    :key="i"
                    :class="['circle', { actived: activeIndex === i - 1 }]"
                ></div>
            </div>
        </div>
        <img src="/img/otc/img-arrow-down.png" class="imgs_arrow"></img>
    </div>
</template>

<script setup>

import { ref, onMounted, onUnmounted } from 'vue'
import VueScrollSnap from "vue-scroll-snap";

const slideCount = 3
const activeIndex = ref(0)
const block1 = ref(null)
const block2 = ref(null)
const block3 = ref(null)

const blockRefs = [block1, block2, block3]

const checkScroll = (event) => {
    const top = event.target.scrollTop
    let idx = 0
    for (let i = 0; i < blockRefs.length; i++) {
        const block = blockRefs[i].value
        if (!block) continue
        if (top >= block.offsetTop - 8) {
            idx = i
        }
    }
    activeIndex.value = idx
}
onMounted(() => {
    //window.addEventListener('scroll', checkScroll)
    // 初始检查一次
    //checkScroll()
})

onUnmounted(() => {
    //window.removeEventListener('scroll', checkScroll)
})
</script>
<style lang="scss" scoped>
.app-box {
    width: 100vw;
    height: 100vh;
}

.item {
    /* Set the minimum height of the items to be the same as the height of the scroll-snap-container.*/

    margin: 0px;
    padding: 0px;
    margin-top: -4px;
}

.imgs {
    width: 100vw;
    margin: 0px;
    padding: 0px;
    object-fit: contain;
    display: block;
}

// 根据实际图片尺寸设置宽高比（sips 读取像素）
img[src="/img/otc/k1.jpg"] {
    aspect-ratio: 1080 / 1786;
}

img[src="/img/otc/k2.jpg"] {
    aspect-ratio: 1080 / 7618;
}

img[src="/img/otc/k3.jpg"] {
    aspect-ratio: 1080 / 8502;
}

.pages {
    display: flex;
    height: 100vh;
    width: 100vw;
    align-items: center;
    justify-content: center;
    background-color: #fff;
}

.scroll-snap-container {
    height: 100vh;
    width: 100vw;
}

.circle-box {
    width: 18px;
    position: fixed;
    left: 20px;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    top: 0px;

    .circle {
        width: 10px;
        height: 10px;
        background-color: #eee;
        border-radius: 5px;
        margin-bottom: 10px;
    }

    .actived {
        background-color: red;
    }
}

.imgs_arrow {
    width: 44px;
    height: 44px;
    position: fixed;
    bottom: 20px;
    left: calc((100vw - 44px) / 2);
    animation: bounce 2s ease-in-out infinite;
}

@keyframes bounce {

    0%,
    100% {
        transform: translateY(0);
    }

    25% {
        transform: translateY(-20px);
    }

    50% {
        transform: translateY(10px);
    }

    75% {
        transform: translateY(-5px);
    }
}
</style>